import React, { useState, useEffect } from 'react';

const TextAnimation = ({ text }) => {
  const [displayText, setDisplayText] = useState('');
  const [isWriting, setIsWriting] = useState(true);

  useEffect(() => {
    const animateText = () => {
      if (isWriting) {
        if (displayText === text) {
          setTimeout(() => {
            setIsWriting(false);
            
          }, 2000);
        } else {
          setDisplayText(prevText => prevText + text.charAt(prevText.length));
        }
      } else {
        if (displayText === '') {
          setTimeout(() => {
            setIsWriting(true);
            
          }, 1000);
        } else {
          setDisplayText(prevText => prevText.slice(0, -1));
        }
      }
    };

    const intervalId = setInterval(animateText, 30);
    return () => clearInterval(intervalId);
  }, [text, displayText, isWriting]);

  return <div id="elementTextWrite">{displayText}</div>;
};

export default TextAnimation;
